import PropTypes from "prop-types"
export const PROP_TYPES = {}

PROP_TYPES.vehicle = PropTypes.shape({
	year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	make: PropTypes.string.isRequired,
	model: PropTypes.string.isRequired,
	diameter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	available_diameters: PropTypes.arrayOf(PropTypes.number).isRequired,
	image: PropTypes.shape({
		vif: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		wheel_positions: PropTypes.shape({
			front: PropTypes.shape({
				x: PropTypes.number,
				y: PropTypes.number,
				radius: PropTypes.number,
				width: PropTypes.number
			}),
			rear: PropTypes.shape({
				x: PropTypes.number,
				y: PropTypes.number,
				radius: PropTypes.number,
				width: PropTypes.number
			})
		}),
		colors: PropTypes.array
	})
})

PROP_TYPES.sort_options = PropTypes.arrayOf(PropTypes.shape({
	name: PropTypes.string.isRequired,
	field: PropTypes.string.isRequired
}))

PROP_TYPES.sort_directions = PropTypes.arrayOf(PropTypes.shape({
	name: PropTypes.string.isRequired,
	value: PropTypes.oneOf(['asc', 'desc'])
}))

export default PROP_TYPES